/**
 *  Search filters Common functionality
 *  Main functionality belongs to Ocean Cruise
 *  The following flows are using FilterView as a Parent View
 *  - Car
 *  - Guided Vacations
 *  - River Cruise
 */

var FilterView = Backbone.View.extend({
  events: {
    "change [data-grouped-filter]": "groupedFiltersToggle",
    "click [data-filter-reset]": "resetFilters",
    "click [data-filter-reset-key]": "resetFilterKey"
  },

  groupedFiltersToggle: function(e) {
    var checkbox = $(e.currentTarget);
    var group = checkbox.data("grouped-filter");

    if (checkbox[0].checked) {
      this.$('[data-grouped-filter-option="' + group + '"]').prop(
        "checked",
        "checked"
      );
    } else {
      this.$('[data-grouped-filter-option="' + group + '"]').prop(
        "checked",
        false
      );
    }

    this.$el.trigger("filtersUpdate");
  },

  /**
   * Controls the display of the filter module
   */

  toggleFilterView: function() {
    // checking viewport size
    let vw = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );

    let filterWrapperModule = this.$el;

    // this is a collapser, forcing opening
    if (
      (this.data && filterWrapperModule.data("filterViewMode") === "mobile") ||
      vw <= parseInt(filterWrapperModule.data("filterViewSize"))
    ) {
      filterWrapperModule.removeAttr("data-collapser-disable-autoclose");
      filterWrapperModule.component().close();
    } else {
      filterWrapperModule.attr("data-collapser-disable-autoclose", true);
      filterWrapperModule.component().open();
    }
  },

  /**
   * Renders Individual filter types
   * Note: Need to enhance sending a filter setting to
   * avoid this type of rendering
   */

  render: function(data) {
    this.data = !!(data && (data.length || Object.keys(data).length));
    this.toggleFilterView();

    if (data.vendors && data.vendors.length) {
      this.renderFilter(this.$("[data-filter-vendor]"), {
        isList: true,
        list: data.vendors,
        filterName: "v",
        selected: this.selectedFilters.v || []
      });
    } else {
      this.removeFilter(this.$("[data-filter-vendor]"));
    }

    if (data.ships && data.ships.length) {
      let shipRenderFilter = {
        isParentChildList: true,
        list: data.ships,
        filterName: "s",
        selected: this.selectedFilters.s || []
      };

      shipRenderFilter = $.extend(shipRenderFilter, this.shipSettings);

      this.renderFilter(this.$("[data-filter-ship]"), shipRenderFilter);
    } else {
      this.removeFilter(this.$("[data-filter-ship]"));
    }

    if (data.destinations && data.destinations.length) {
      this.renderFilter(this.$("[data-filter-destination]"), {
        isList: true,
        list: data.destinations,
        filterName: "d",
        selected: this.selectedFilters.d || []
      });
    } else {
      this.removeFilter(this.$("[data-filter-destination]"));
    }

    if (data.departure_ports && data.departure_ports.length) {
      this.renderFilter(this.$("[data-filter-departure-port]"), {
        isList: true,
        list: data.departure_ports,
        filterName: "dp",
        selected: this.selectedFilters.dp || []
      });
    } else {
      this.removeFilter(this.$("[data-filter-departure-port]"));
    }

    if (data.return_ports && data.return_ports.length) {
      this.renderFilter(this.$("[data-filter-return-port]"), {
        isList: true,
        list: data.return_ports,
        filterName: "rp",
        selected: this.selectedFilters.rp || []
      });
    } else {
      this.removeFilter(this.$("[data-filter-return-port]"));
    }

    if (data.duration && data.duration.min && data.duration.max) {
      this.renderFilter(this.$("[data-filter-duration]"), {
        isRange: true,
        range: data.duration,
        filterName: "du",
        isDuration: true,
        selected: this.selectedFilters.du || {}
      });
    } else {
      this.removeFilter(this.$("[data-filter-duration]"));
    }

    if (data.tonnage && data.tonnage.length) {
      this.renderFilter(this.$("[data-filter-tonnage]"), {
        isList: true,
        list: data.tonnage,
        filterName: "to",
        selected: this.selectedFilters.to || []
      });
    } else {
      this.removeFilter(this.$("[data-filter-tonnage]"));
    }

    if (data.guest_capacity && data.guest_capacity.length) {
      this.renderFilter(this.$("[data-filter-guest-capacity]"), {
        isList: true,
        list: data.guest_capacity,
        filterName: "gc",
        selected: this.selectedFilters.gc || []
      });
    } else {
      this.removeFilter(this.$("[data-filter-guest-capacity]"));
    }

    if (data.from_prices && data.from_prices.length) {
      const containerEl = this.$("[data-filter-from-prices]");
      containerEl.empty();

      data.from_prices.forEach(price => {
        // verify that price min & max was provided
        if (Number.isFinite(price.min) && Number.isFinite(price.max)) {
          const currencyEl = $(
            this.template({
              isFromPriceContainer: true,
              currency: price.currency
            })
          );

          containerEl.append(currencyEl);
          this.renderFromPrice(currencyEl, price);
        }
      });
    } else {
      this.removeFilter(this.$("[data-filter-from-prices]"));
    }

    if (
      data.rewards_from_price &&
      data.rewards_from_price.min &&
      data.rewards_from_price.max &&
      data.rewards_from_price.min !== data.rewards_from_price.max
    ) {
      this.renderFilter(this.$("[data-filter-rewards-price]"), {
        isRange: true,
        range: data.rewards_from_price,
        postfix: data.rewards_from_price.unit,
        filterName: "rpi",
        isRewards: true,
        selected: this.selectedFilters.rpi || {}
      });

      this.$("[data-filter-rewards-price]")
        .find("[data-rewards-unit]")
        .html(data.rewards_from_price.unit);
    } else {
      this.removeFilter(this.$("[data-filter-rewards-price]"));
    }

    // this will avoid the auto-refreshing of promotions
    // for non dynamic filters and if there's already promotions ignore loading
    // only dynamic promo filter available is Ocean Cruise

    if (!this.ignorePromotionRender) {
      this.renderPromotions(data);
    } else if (this.ignorePromotionRender && this.promotionTotal) {
      this.filtersLoaded.push(this.$("[data-filter-promotion]"));
      this.filtersLoaded.push(this.$("[data-filter-promotion-id]"));
      this.filtersLoaded.push(this.$("[data-filter-marketing-code]"));
    }

    this.isInitialized = true;

    this.$el.loadComponents();

    // Using the Initialized flag we trigger filtersLoaded which belongs to
    // Search Results View and triggers to stop loading the results
    this.$el.trigger("filtersLoaded");
  },

  renderFromPrice: function(filterEL, data) {
    data.min = Math.ceil(data.min);
    data.max = Math.ceil(data.max);

    if (data.min && data.max) {
      var priceLimits = this.stateModel.get("priceLimits");

      priceLimits[data.currency] = {
        min: String(data.min),
        max: String(data.max)
      };

      this.stateModel.set("priceLimits", priceLimits);

      this.renderFilter(this.$(filterEL), {
        isRange: true,
        isCurrency: true,
        range: data,
        prefix: data.currency_symbol,
        postfix: data.currency,
        currency: data.currency,
        filterName: "pi[" + data.currency + "]",
        selected: this.selectedFilters.pi
          ? this.selectedFilters.pi[data.currency]
          : {}
      });
    }

    if (data.min == data.max) {
      this.$(".filter-section-price").removeClass("is-loading");
      this.removeFilter(this.$("[data-filter-from-prices]"));
    }
  },

  // Groups filter options to avoid duplicated keys
  groupOptionsBy: function(collection, key) {
    // First group promos that have the same name
    var groups = _.groupBy(collection, function(promo) {
        return promo[key];
      }),
      groupsOutput = [];

    // Ignore the groups that have more than 1 items
    groups = _.filter(groups, function(promo) {
      return promo.length > 1;
    });

    // Output right original response instantly if there are no groups
    if (!groups.length) {
      return collection;
    }

    // Index groups of items
    _.each(
      groups,
      function(promos) {
        // group object
        var groupOutput = {
          id: _.uniqueId("promo-guid-"),
          is_group: true,
          items: promos,
          selected: this.selectedFilters.pname || []
        };

        // store key
        groupOutput[key] = promos[0][key];

        // append to groups array
        groupsOutput.push(groupOutput);
      }.bind(this)
    );

    // Remove all group promos from dataset
    collection = _.reject(
      collection,
      function(promo) {
        var ref = {};

        ref[key] = promo[key];

        return _.findWhere(groupsOutput, ref);
      }.bind(this)
    );

    // Reinsert indexed groups of promos
    collection = _.extend(collection, groupsOutput);

    // Reorder alphabetically
    collection = _.sortBy(
      collection,
      function(promo) {
        return promo[key].toLowerCase();
      }.bind(this)
    );

    return collection;
  },

  // The promotions come initially from a separate endpoint
  // using this method we can call the promotions individually
  // without affecting the primary filters
  renderPromotions: function(data) {
    if (data && data.promotion_counts && data.promotion_counts.length) {
      this.renderFilter(this.$("[data-filter-promotion]"), {
        isSwitch: true,
        filterName: "po",
        isPromotions: true,
        selected: this.selectedFilters.po || []
      });

      this.$("[data-filter-promotions]").removeClass("is-hidden");
    } else {
      this.removeFilter(this.$("[data-filter-promotion]"));
    }

    if (data && data.promotions) {
      this.promotionTotal = data.promotions.length;

      let promotionRenderFilter = {
        isComboGroupList: true,
        list: data.promotions,
        filterName: "pid",
        selected: this.selectedFilters.pname || []
      };

      promotionRenderFilter = $.extend(
        promotionRenderFilter,
        this.promotionSettings
      );

      this.renderFilter(
        this.$("[data-filter-promotion-id]"),
        promotionRenderFilter
      );

      this.renderFilter(this.$("[data-filter-marketing-code]"), {
        isInput: true,
        filterName: "pmc",
        selected: this.selectedFilters.pmc || null
      });
    } else {
      this.removeFilter(this.$("[data-filter-promotion-id]"));
      this.removeFilter(this.$("[data-filter-marketing-code]"));
    }

    if (data && data.tags && data.tags.length) {
      this.renderFilter(this.$("[data-filter-promotion-tag-id]"), {
        isList: true,
        list: data.tags,
        filterName: "ptid",
        selected: this.selectedFilters.ptid || []
      });

      this.$("[data-filter-promotions]").removeClass("is-hidden");
    } else {
      this.removeFilter(this.$("[data-filter-promotion-tag-id]"));
    }

    if (!data || (!data.promotion_counts && !data.promotions)) {
      this.removeFilter(this.$("[data-filter-promotion]"));
    }
  },

  renderFilter: function(filterEl, data) {
    filterEl
      .find("[data-filter-items]")
      .empty()
      .html(this.template(data))
      .removeClass("is-hidden");

    // this removes the loading status of the whole section
    this.filtersLoaded.push(filterEl);
  },

  startFilterLoading: function() {
    this.isInitialized = false;
    this.filtersLoaded = [];
    this.$el.trigger("filtersLoaded");

    this.$("[data-filter-section]").addClass("is-loading");
    this.$("[data-filter-items]").addClass("is-loading");
  },

  stopFilterLoading: function() {
    _.each(this.filtersLoaded, filter => {
      filter.removeClass("is-loading is-hidden");
      filter.find("[data-filter-items]").removeClass("is-loading");
    });
  },

  removeFilter: function(filterEl) {
    filterEl.hide().addClass("is-hidden");
  },

  hideView: function() {
    this.$el.hide();
  },

  setSelectedFilters: function(selections) {
    this.selectedFilters = selections;
  },

  getSelectedFilters: function() {
    var el = this.$("[data-search-results-filters]").clone();

    return $("<form></form>")
      .append(el)
      .serializeJSON();
  },

  /**
   * This method resets the filter fields
   *
   * @param key
   */
  resetFields: function(key) {
    var filterTypes = [
      "data-filter-field",
      "data-filter-check",
      "data-filter-radio",
      "data-filter-range"
    ];
    var x;

    for (x in filterTypes) {
      var resetKey = "";

      if (key) {
        // only reset a specific filter key if requested
        resetKey = "[" + filterTypes[x] + '="' + key + '"]';
      }

      // reset text inputs
      this.$('input[type="text"]' + resetKey).each(function(index, el) {
        $(el).val(null);
      });

      // reset radios and checkboxes
      this.$(
        'input[type="radio"]' + resetKey + ', input[type="checkbox"]' + resetKey
      ).each(function(index, el) {
        $(el).prop("checked", false);
      });

      // reset selects
      this.$("select" + resetKey).each(function(index, el) {
        $(el).val(null);
      });

      // reset range sliders
      this.$('[data-component="range-slider"]' + resetKey).each(function(
        index,
        el
      ) {
        $(el)
          .component()
          .reset();
      });
    }
  },

  /**
   * This method resets the filters
   */
  resetFilters: function() {
    this.resetFields();
  },

  /**
   * This method resets a specific filter key
   *
   * @param event
   */
  resetFilterKey: function(event) {
    var key = $(event.currentTarget).data("filterResetKey");

    this.resetFields(key);
  },

  initialize: function(options) {
    this.isInitialized = false;

    // setting initial render settings for certain filters
    // as they differ from ocean settings

    this.filtersLoaded = [];

    this.ignorePromotionRender = this.ignorePromotionRender || false;
    this.shipSettings = this.shipSettings || {};
    this.promotionSettings = this.promotionSettings || {};

    this.selectedFilters = {};

    this.stateModel = options.stateModel;

    this.sectionContainer = this.$("[data-filter-section]");

    // Filter View has a data-component attached, init itself.
    this.$el.component();

    this.toggleFilterView();

    // resize event to control filter behavior
    $(window).on("resizeView", this.toggleFilterView.bind(this));

    this.template = Handlebars.compile(
      this.$("[data-filters-template]").length
        ? this.$("[data-filters-template]").html()
        : ""
    );
  }
});

module.exports = FilterView;
